import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Aggregations, Filter } from '../../filters';
import { FormGroup, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FilterComponent } from '../filter.component';

@Component({
  selector: 'cbre-filter-group',
  templateUrl: './filter-group.component.html',
  styleUrls: ['./filter-group.component.scss'],
  imports: [CommonModule, MatIconModule, FilterComponent, FormsModule],
})
export class FilterGroupComponent {
  private _filter: Filter | null = null;

  @Input()
  get filter(): Filter | null {
    return this._filter;
  }
  set filter(value: Filter | null) {
    this._filter = value;
    this.buildFilterItems();
  }

  @Input() form: FormGroup<Record<string, any>> = new FormGroup({});
  @Input() aggregations: Aggregations = {};
  @Input() canRemoveFilter = false;
  @Input() showLabel = true;

  @Output() removeFilter = new EventEmitter();
  @Output() filterOptionChange = new EventEmitter<Filter>();

  public filterItems: Filter[] = [];

  private buildFilterItems(): void {
    if (!this._filter) {
      this.filterItems = [];
      return;
    }
    this.filterItems = [...(this._filter.associations ?? [])].sort(
      (a, b) => (Number(a?.groupOrder) || 0) - (Number(b?.groupOrder) || 0)
    );
  }

  onRemoveFilter(event: Event, filter: Filter): void {
    event.stopPropagation();
    this.removeFilter.emit(filter);
  }
}
